/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Themesystem1Inputs */

const zh_user_themesystem1 = /** @type {(inputs: User_Themesystem1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跟随系统`)
};

const en_user_themesystem1 = /** @type {(inputs: User_Themesystem1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

const es_user_themesystem1 = /** @type {(inputs: User_Themesystem1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema`)
};

/**
* | output |
* | --- |
* | "System" |
*
* @param {User_Themesystem1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const user_themesystem1 = /** @type {((inputs?: User_Themesystem1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Themesystem1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_user_themesystem1(inputs)
	if (locale === "en") return en_user_themesystem1(inputs)
	return es_user_themesystem1(inputs)
});
export { user_themesystem1 as "user_themeSystem" }